import React, { Component } from "react";
import { SOCIALS } from "../../constants";

class SelfSpiel extends Component {
  renderSocials() {
    let socials = SOCIALS.map(({ title, icon, url }) => {
      return (
        <li key={`ss ${title}`}>
          <a href={url} target="_blank">
            <span className={icon}></span>
          </a>
        </li>
      );
    });

    return socials;
  }

  render() {
    return (
      <section id="about">
        <div className="container-fluid">
          <div className="row position-relative">
            <div
              id="white-panel"
              className="ml-auto col-sm-12 offset-md-6 col-md-6"
            >
              <h2 className="anim_piece">About</h2>
              <p className="anim_piece">
                TECHNICAL LEAD, CONSULTANT AND SAAS FOUNDER
              </p>
              <p className="anim_piece">
                I'm Fernan de Dios, a technical lead and consultant, product builder,
                and SaaS founder based in Pasig City, Philippines. I build
                products like Embedful and AIVA, and advise on SaaS and AI
                product strategy.
              </p>
              <p className="anim_piece">
                I’m always interested in conversations about SaaS, AI, and
                product collaboration. Feel free to reach out, and I’d be happy
                to talk about how we might work together.
              </p>
              <ul className="anim_piece social-list">{this.renderSocials()}</ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SelfSpiel;
